function BoxImg(container){
	var _this = this;
	this.container = $(container);
	this.boxImg = this.container.find('.box-img-text, .box-business-stage-text');
	this.container.bind({
		mouseenter: function(){
			_this.boxImg.addClass('hovers');
			setTimeout(function() {
				if(_this.boxImg.hasClass('hovers')) {
					_this.boxImg.animate({top: 0},{duration: 400, easing: 'easeOutCubic', queue: false});
				}
			}, 300);
		},
		mouseleave: function(){
			_this.boxImg.removeClass('hovers');
			_this.boxImg.animate({top: 190},{duration: 600, easing: 'easeOutCubic', queue: false});
		}
	});
}

if (typeof define === "function" && define.amd) {
	define('Controls/BoxImg',['easing'], function() {
		return BoxImg;
	});
};
